// Money display for the analytics dashboard. The wire carries fixed 6-dp USD
// strings (`UsdSchema`); this is the human projection.
//
// A plain `Intl` currency format renders anything under $0.005 as "$0.00",
// which makes real sub-cent model spend (a $0.0031 Haiku call) look like zero.
// Below one cent we therefore widen to 4 fraction digits ($0.0031) while
// keeping the conventional 2-dp rendering for a cent and above — and for exact
// zero, which IS zero and should read as "$0.00", not "$0.0000".

/**
 * Format a 6-dp USD wire string (or number) for display in `locale`.
 * `< $0.01` (non-zero) → up to 4 fraction digits; otherwise standard 2-dp
 * currency formatting.
 */
export const formatUsdDisplay = (
  value: string | number,
  locale: string,
): string => {
  const n = typeof value === "number" ? value : Number(value);
  const safe = Number.isFinite(n) ? n : 0;
  const abs = Math.abs(safe);
  const subCent = abs > 0 && abs < 0.01;
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: "USD",
    ...(subCent
      ? { minimumFractionDigits: 2, maximumFractionDigits: 4 }
      : {}),
  }).format(safe);
};
